import { render, staticRenderFns } from "./Chapter8_NO.vue?vue&type=template&id=2c36eb4c&scoped=true&"
import script from "./Chapter8_NO.vue?vue&type=script&lang=js&"
export * from "./Chapter8_NO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36eb4c",
  null
  
)

export default component.exports